import api from '../api/api';

let inflight = null;
let cached = null;

/**
 * Homepage random books — dedupes StrictMode double-mount and short revisits.
 */
export async function loadHomepageBooks({ limit = 24, force = false } = {}) {
  if (!force && cached) {
    return cached;
  }
  if (!force && inflight) {
    return inflight;
  }

  inflight = api
    .get('api/v1/pdf_parser/public_domain_books/', {
      params: { random: 1, limit },
    })
    .then(({ data }) => {
      const result = {
        books: data?.public_books || [],
        totalCount: data?.total_count ?? 0,
      };
      cached = result;
      inflight = null;
      return result;
    })
    .catch((err) => {
      inflight = null;
      throw err;
    });

  return inflight;
}

export function clearHomepageBooksCache() {
  cached = null;
  inflight = null;
}
